import { render } from "./MonitorPage.vue?vue&type=template&id=15478d49&scoped=true"
import script from "./MonitorPage.vue?vue&type=script&lang=js"
export * from "./MonitorPage.vue?vue&type=script&lang=js"

import "./MonitorPage.vue?vue&type=style&index=0&id=15478d49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15478d49"]])

export default __exports__